import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class UtilsService {
    
    public static recursiveDeepCopy(obj: any): any {
		let newObj;
		let index;

		if (typeof obj !== 'object') {
			return obj;
		}

		if (!obj) {
			return obj;
		}

		if ('[object Array]' === Object.prototype.toString.apply(obj)) {
			newObj = [];
			for (index = 0; index < obj.length; index += 1) {
				newObj[index] = UtilsService.recursiveDeepCopy(obj[index]);
			}
			return newObj;
		}

		newObj = {};
		for (const key in obj) {
			// obj.hasOwnProperty(i)
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				newObj[key] = UtilsService.recursiveDeepCopy(obj[key]);
			}
		}
		return newObj;
	}
}